// Jediný zdroj pravdy pro vzhled značky turniketu.
// Používá editor (JSX, MapEditor.js) i serializace do uloženého SVG
// (serializeScene.js → MapSvg) — obě vykreslení tak zůstávají identická.
//
// Kotva = střed (0,0), tj. značka sedí přesně na svém bodu na mapě.
// Vzhled: vybarvený zaoblený obdélník (chip) s jemným stínem a bílým
// glyfem tripodového turniketu uprostřed. Kreslí se kolem počátku,
// velikost řídí per-marker `scale` (transform scale kolem středu).
export const MARKER = {
    fill: "#2563eb",     // primary-container (výplň chipu)
    stroke: "#1e3a8a",   // tmavší obrys
    arm: "#ffffff",      // glyf
    label: "#1e293b",
    DEFAULT_SCALE: 1,
    MIN_SCALE: 0.5,
    MAX_SCALE: 3,
    // výběrový rámeček (zaoblený, o něco větší než chip)
    SELECT: {x: -24, y: -24, w: 48, h: 48, rx: 15},
    LABEL_DY: 34,
    // tripod turniketu ze středu (0,0): nahoru + dvě spodní ramena
    glyphPath: "M0 0 V-11 M0 0 L9.5 5.5 M0 0 L-9.5 5.5",
};

// Vnitřek značky jako SVG řetězec (bez obalového <g>, bez popisku) — sdíleno
// se serializací. Kreslí se v lokálních souřadnicích, škáluje obalový transform.
export function markerBodySvg() {
    const {fill, stroke, arm, glyphPath} = MARKER;
    return (
        // stín (posunutý zaoblený obdélník)
        `<rect x="-19" y="-16" width="40" height="40" rx="12" fill="rgba(0,0,0,0.18)"/>` +
        // chip
        `<rect x="-20" y="-20" width="40" height="40" rx="12" fill="${fill}" stroke="${stroke}" stroke-width="1.5"/>` +
        // glyf turniketu (tripod)
        `<path d="${glyphPath}" fill="none" stroke="${arm}" stroke-width="3" stroke-linecap="round"/>` +
        `<circle cx="0" cy="0" r="2.4" fill="${arm}"/>`
    );
}

// Bezpečné omezení a zaokrouhlení faktoru velikosti.
export function clampScale(s) {
    const n = Number(s);
    if (Number.isNaN(n)) return MARKER.DEFAULT_SCALE;
    return Math.min(MARKER.MAX_SCALE, Math.max(MARKER.MIN_SCALE, Math.round(n * 10) / 10));
}
